import { getUrl } from 'aws-amplify/storage';

const GetReflectionTeams = async (path) => {
  try {
    const { url } = await getUrl({ path: 'public/teams_latest.json' });

    const response = await fetch(url);
    const json = await response.json();

    console.log(json);
    return json;
  } catch (error) {
    console.error('Error fetching JSON data:', error);
    return [];
  }
};

export default GetReflectionTeams;